module.exports = __webpack_public_path__ + "img/DSC_4399.bc54dff1.png";